// Normaliza a data que o webhook de consulta de MDF-e devolve.
//
// O webhook nao garante formato: manda ISO em alguns casos e DD/MM/YYYY em
// outros. A data BR e o problema — no backend o Sequelize a reparseia com moment
// assumindo MM/DD, entao dia <= 12 grava mes e dia trocados e dia > 12 virava a
// string "Invalid date", que o banco recusa e derruba a abordagem inteira.
//
// O backend tambem se defende (virgem/src/app/utils/parseTimestamp.js). Aqui a
// normalizacao serve para o usuario saber na hora que a data nao veio boa, e
// para o valor exibido na tela ser o mesmo que sera gravado.
//
// Retorna string ISO (yyyy-MM-dd'T'HH:mm:ss) ou null quando nao ha data
// aproveitavel — nota sem data de emissao grava, nota com data podre nao.
export default function normalizaDataMdfe(valor) {
  if (!valor || typeof valor !== 'string') return null;

  const texto = valor.trim();
  if (texto === '' || LIXO.includes(texto.toLowerCase())) return null;

  const br = texto.match(BR);
  if (br) {
    const [, dia, mes, ano, hora = '00', min = '00', seg = '00', offset] = br;
    const data = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;

    // Hora fora de faixa derruba so a hora, nao a data — mesma regra do
    // parseTimestamp do backend, para as duas bordas concordarem.
    const horaValida =
      Number(hora) <= 23 && Number(min) <= 59 && Number(seg) <= 59;

    // O offset vem no dado do webhook ("...17:51:08-03:00") e e preservado: sem
    // ele o instante passaria a depender do fuso do processo do backend. Offset
    // impossivel derruba so o offset, nunca a data.
    const iso = horaValida
      ? `${data}T${hora.padStart(2, '0')}:${min}:${seg}${offsetValido(offset) ? offset : ''}`
      : `${data}T00:00:00`;

    return dataReal(iso) ? iso : null;
  }

  // Qualquer outro formato: so aceita se o Date reconhecer.
  const data = new Date(texto);
  return Number.isNaN(data.getTime()) ? null : texto;
}

const LIXO = ['invalid date', 'nan', 'null', 'undefined', '-', '0'];

const BR = /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:?\d{2})?)?/;

function offsetValido(offset) {
  if (!offset) return false;
  if (offset === 'Z') return true;

  const partes = offset.slice(1).replace(':', '').match(/\d{2}/g);
  return Number(partes[0]) <= 14 && Number(partes[1]) <= 59;
}

// Barra 31/02 e afins, que new Date() aceita rolando para o mes seguinte.
function dataReal(iso) {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return false;
  return data.getDate() === Number(iso.slice(8, 10));
}
